module.exports = __webpack_public_path__ + "static/2-310b524c4438c5c5cd349e507ce94227.png";